export const MerchantSelectionErrorViewStyles = {
  container: 'flex flex-row justify-center text-center',
}
